import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import logo from 'assets/image/header__logo.svg';
import './Header.scss';

interface HeaderProps {
  pageTitle?: string;
}

const Header: React.FC<HeaderProps> = ({ pageTitle }) => {
  return (
    <Container fluid>
      <div className="p-3">
        <img src={logo} alt="" />
      </div>
      <Navbar className="header-navbar">
        <div className="fw-semibold mx-auto fw-bold fs-4">{pageTitle}</div>
      </Navbar>
    </Container>
  );
};

export default Header;
